import { graphql } from '@/gql';
import type { TeamLeadOperatorActivitiesSummaryQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { OperatorActivitySummary } from '@/models/operator';

export const fetchTeamLeadOperatorActivitiesSummary = async ({
  operatorId,
  slackId,
  startDate,
  endDate,
}: TeamLeadOperatorActivitiesSummaryQueryVariables): Promise<OperatorActivitySummary[]> => {
  const response = await queryExecute({
    variables: {
      operatorId,
      slackId,
      startDate,
      endDate,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query TeamLeadOperatorActivitiesSummary($operatorId: String, $slackId: String, $startDate: String!, $endDate: String!) {
        teamLeadOperatorActivitiesSummary(operatorId: $operatorId, slackId: $slackId, startDate: $startDate, endDate: $endDate) {
          operatorId
          operatorName
          operatorSlackId
          total
          online
          offline
          callback
          callbackActual
          callissue
          coaching
          moretimefor
          technical
          break
          lunch
          restroom
          logoutlogin
          browserclosed
          onlineDateTime
          offlineDateTime
          notes {
            field
            value
          }
        }
      }
    `),
  });

  return response.data.teamLeadOperatorActivitiesSummary;
};
